export class GlobalConstants {

  // DDB Constants
  public static BUSINESS_UNIT_AND_FROM_COUNTRY_CODE = 'businessUnit_fromCountryCode';
  public static BUSINESS_UNIT = 'businessUnit';
  public static BUSINESS_USE_CASE = 'businessUseCase';
  public static FROM_COUNTRY_CODE = 'fromCountryCode';
  public static COMPONENT_KEY_PLACE_HOLDER = 'componentKeyPlaceholder';
  public static COMPONENT_KEY_VALUE = 'componentKeyValue';
  public static LOOK_UP_KEYS = 'lookUpKeys';
  public static LOOK_UP_KEYS_ORDER = 'order';
  public static LOOK_UP_KEYS_REGEX = 'regex';
  public static LOOK_UP_KEYS_KEY_NAME = 'name';
  public static TRANSIT_TIME_TYPE = 'transitTimeType';
  public static COMPONENT_KEY_VALUE_SEPARATOR = ':';
  public static TRANSIT_TIME_FILE = 'transitTimeFile';

  public static APPROVAL_STATUS = 'approvalStatus';
  public static CURRENT_TRANSIT_TIME = 'currentTransitTime';
  public static LOOK_UP_KEY_TEXT_AREA = 'lookUpKeyTexArea';
  public static ARC = 'arc';

  // Success Messages
  public static TITLE_SUCCESS = 'Success';
  public static TITLE_ERROR = 'Error';
  public static REQUEST_SUCCESSFUL = 'Request Successful';
  public static REQUEST_FAILED = 'Request Failed';
  public static FILE_UPLOAD_SUCCESSFUL = 'File Upload Successful';
  public static FILE_UPLOAD_FAILED = 'File Upload Failed';
  public static APPROVAL = 'Approval';
  public static REJECTION = 'Rejection';
  public static SPACE = ' ';

  // Error Messages
  public static MAXIMUM_LOOK_UP_KEYS_REACHED = 'Maximum look up keys reached';
  public static MINIMUM_LOOK_UP_KEYS_REACHED = 'Can\'t go beyond';
  public static DUPLICATE_LOOK_UP_KEYS = 'Duplicate look up keys';
  public static INVALID_REGEX = 'Invalid Regex';
  public static REFRESH_SESSION_REQUIRED = 'Reloading page in order to keep session updated'

  // Info Messages
  public static TRANSIT_TIME_TYPE_ALERT_MESSAGE = 'Before submitting Carrier Provided update, please make sure that the file contains only carrier provided transit times and no row is updated through any manual or automated process. If any change is made in carrier provided data, select Computed transit time from the drop down.'

  // Value constants
  public static ZERO = 0;
  public static ONE = 1;
  public static PAGE_RELOAD_INTERVAL = 3000;

  //ENDPOINTS
  public static SET_TRANSIT_TIME_CONFIGURATION_ENDPOINT = '/set-transit-time-configuration/';
  public static FETCH_ALL_TRANSIT_TIME_REQUESTS_ENDPOINT = '/fetch-all-transit-time-requests/';
  public static SUBMIT_TRANSIT_TIME_APPROVAL_REQUEST_ENDPOINT = '/submit-transit-time-approval-request/';
  public static SUBMIT_PAD_TRANSIT_TIME_REQUEST_ENDPOINT = '/submit-pad-transit-time-request/';
  public static UPDATE_TRANSIT_TIME_TYPE_ENDPOINT = '/update-transit-time-type/';
  public static PROCESS_TRANSIT_TIME_REQUEST_ENDPOINT = '/process-transit-time-request/';
  public static PROCESS_TRANSIT_TIME_OVERRIDES_ENDPOINT = '/process-transit-time-override-request/';
  public static FETCH_ALL_TRANSIT_TIME_DATA_VERSIONS_ENDPOINT = '/fetch-all-transit-time-data-versions/';
  public static CHANGE_TRANSIT_TIME_VERSION_ENDPOINT = '/change-transit-time-version/';
  public static FETCH_ALL_PENDING_APPROVAL_REQUESTS = '/fetch-all-pending-approval-requests/';
  public static PROCESS_TRANSIT_TIME_FILE_UPLOAD_TO_BUSINESS_S3 = '/process-transit-time-file-upload-to-business-s3/';
  public static INVOKE_TRANSIT_TIME_OVERRIDES_WORKFLOW_ENDPOINT = "/invoke-smart-transit-time-overrides-workflow/";
  public static FETCH_ALL_TRANSIT_TIME_VALIDATION_THRESHOLD = "/fetch-transit-time-update-validation-thresholds";
  public static SAVE_TRANSIT_TIME_UPDATE_VALIDATION_THRESHOLDS = "/save-transit-time-update-validation-thresholds";
  public static DELETE_TRANSIT_TIME_UPDATE_VALIDATION_THRESHOLDS = "/delete-transit-time-update-validation-thresholds";
  public static FETCH_TRANSIT_TIME_UPDATE_VALIDATION_RULES = "/fetch-transit-time-update-validation-rules";
  public static REMOVE_LANES_FROM_TRANSIT_TIME_FILE_ENDPOINT = '/remove-lanes-from-transit-time-file';
  public static CREATE_BINDLE_RESOURCE_ENDPOINT = '/create-bindle-resource';
  public static GET_RESOURCE_PERMISSION_ENDPOINT = '/get-bindle-permission';
  public static REQUEST_RESOURCE_PERMISSION_ENDPOINT = '/request-resource-permission';
  public static GET_ALL_REQUESTED_PERMISSIONS = '/get-all-requested-permissions'
  public static UPDATE_REQUESTED_PERMISSIONS = '/update-requested-permissions'
  public static CHECK_RESOURCE_REFERENCE = '/check-resource-reference'
  public static UPDATE_TRANSIT_TIME_CONFIGURATION_ENDPOINT = '/update-transit-time-configuration';

  // Transit Time Configuration update request/response fields
  public static MAPPED_SERVICES = 'mappedServices';
  public static UPDATED_BY = 'updatedBy';
  public static STATUS_KEY = 'status';
  public static MESSAGE_KEY = 'message';
  public static STATUS_SUCCEEDED = 'SUCCEEDED';
  public static STATUS_FAILED = 'FAILED';
  public static UNKNOWN_USER = 'UNKNOWN';

  // Miscellaneous
  public static HISTORY_KEYWORD = 'history';
  public static DOWNLOAD_KEYWORD = 'download';
  public static ALL_STRING = 'ALL';
  public static EMPTY_STRING = '';
  public static CARRIER_PROVIDED_KEYWORD = 'CARRIER_PROVIDED';
  public static COMPUTED_KEYWORD = 'COMPUTED';
  public static ML_OPTIMIZED_KEYWORD = 'ML_OPTIMIZED';
  public static HYBRID_TRANSIT_TIME_TYPE = 'HYBRID_TRANSIT_TIME_TYPE';
  public static PRECISION_OPTIMIZED_KEYWORD = 'PRECISION_OPTIMIZED';
  public static UPDATE_TRANSIT_TIME_OVERRIDES_TYPE = 'updateOverridesType';
  public static TRANSIT_TIME_OVERRIDES_FILE = 'transitTimeOverridesFile';
  public static SLASH = '/';
  public static months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
  ];
  public static days = [
    'Sun',
    'Mon',
    'Tue',
    'Wed',
    'Thu',
    'Fri',
    'Sat'
  ];
  public static FILE_UPLOAD_BUCKET = 'transit-time-uploaded-files-devo';
  public static UPDATES_BUCKET = 'transit-time-updates-devo';
  public static NUMBER_OF_RECENT_UPLOADED_FILES = 20;
  public static S3_FILE_PATH = 's3FilePath';
  public static ACTION = "action";
  public static UPLOADS_FOLDER_NAME = "uploads"
  public static OVERRIDE_REMOVAL_FOLDER_NAME = "removals"
  public static REMOVE_OVERRIDES = "Remove Overrides"
  public static REMOVE_OVERRIDES_ACTION = "REMOVE_OVERRIDES"
  public static ADD_OVERRIDES_ACTION = "ADD_OVERRIDES"
  public static THRESHOLD = "Threshold"
  public static CRON_EXPRESSION = "cronExpression"
  public static CRON_DESCRIPTOR = "cronDescriptor"
  public static TRANSIT_TIME = "transitTime"
  public static TRANSIT_TIME_UPLOAD_TYPE = 'uploadType'
  public static UI_UPLOAD = 'UI_UPLOAD';
  public static S3_UPLOAD = 'S3_UPLOAD';

  // Response
  public static TRANSIT_TIME_CONFIGURATIONS_RESPONSE_KEY = 'transitTimeConfigurations';
  public static TRANSIT_TIME_REQUESTS_RESPONSE_KEY = 'transitTimeRequests';

  // Request Status Constants
  public static REQUEST_STATUS_COMPLETED = 'COMPLETED';
  public static REQUEST_STATUS_REJECTED = 'REJECTED';
  public static TRANSIT_TIME_DATA_VERSIONS_RESPONSE_KEY = 'transitTimeDataVersions';
  public static IS_WORKFLOW_RUNNING_RESPONSE_KEY = 'isWorkflowRunning';
  public static PROCESS_TRANSIT_TIME_OVERRIDES_RESPONSE_MESSAGE_KEY = 'message';
  public static BUCKET = 'bucketName';
  public static KEY = 'key';
  public static TIME_STAMP = 'timestamp';

  // Arc Constants
  public static ARC_OOC = 'OOC';
  public static ARC_DOM = 'DOM';
  public static BUSINESS_USE_CASE_SEPARATOR = ';';

  // Mapping Constants
  public static MAPPING_USE_CASES = 'usecases';
  public static MAPPING = 'mapping';

  public static TRANSIT_TIME_COLUMN = ['TRANSIT_TIME'];
  public static MIN_MAX_TRANSIT_TIME_COLUMNS = ['MIN_TRANSIT_TIME', 'MAX_TRANSIT_TIME'];
  public static URL_UTILS_REGION = 'region';
  public static URL_UTILS_ARC = 'arc';
  static SINGLE_KEYWORD = 'Schema Format of Single value TT file';
  static RANGE_KEYWORD = 'Schema Format of Range value TT file';
  static CREATED_BY = 'createdBy';
  static APPROVER_AND_REQUESTER_ARE_SAME = "Approver and requester can't be same";
  static APPROVED_BY = 'approvedBy';
  static REQUESTED_APPROVER = 'requestedApprover';
  static ALIAS = 'alias';
  static SINGLE_TRANSIT_TIME_COLUMNS = 'singleTransitTimeColumns';
  static RANGE_TRANSIT_TIME_COLUMNS = 'rangeTransitTimeColumns';

  // Request body parameters for upload to business-s3 request.
  public static TRANSIT_TIME_BUSINESS_BUCKET = "transitTimeBusinessBucket";
  public static TRANSIT_TIME_BUSINESS_FILE_KEY = "transitTimeBusinessFileKey";
  public static TRANSIT_TIME_UPLOAD_BUCKET = "transitTimeUploadBucket";
  public static TRANSIT_TIME_UPLOAD_FILE_KEY = "transitTimeUploadFileKey";
  public static METADATA = "metadata";

  public static CHECK_USER_PERMISSIONS_ERROR = 'Getting error while checking user permissions';
  public static NO_PERMISSION_MSG =
  "Access denied. You can request the required permissions from the 'Request Permissions' page";
  public static NO_OPERATIONS_FOUND = 'No operation group mapped for pageId:';
  public static SOMETHING_WENT_WRONG = 'Something went wrong, please try again after sometime'

}
